import type { ChipProps } from "@mui/material";
import {
	type LucideIcon,
	TrendingDownIcon,
	TrendingUpIcon,
} from "lucide-react";
import { formatPercent } from "web_myplann/Shared/Utils/numberFormatters";

type TrendChipProps = {
	color: ChipProps["color"];
	Icon: LucideIcon;
	label: string;
};

const TREND = {
	positive: { color: "success", Icon: TrendingUpIcon, sign: "+" },
	negative: { color: "error", Icon: TrendingDownIcon, sign: "" },
} as const satisfies Record<
	"positive" | "negative",
	Omit<TrendChipProps, "label"> & { sign: string }
>;

export const getTrendChipProps = (
	percent: number | null | undefined,
): TrendChipProps | null => {
	if (percent === null || percent === undefined) {
		return null;
	}

	const { color, Icon, sign } = percent >= 0 ? TREND.positive : TREND.negative;

	return { color, Icon, label: `${sign}${formatPercent(percent)}` };
};
